import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import RoleViewModel from '../../../../core/features/authorization/viewmodels/RoleViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      modulePermissions: 'Authorization-Roles',
      item: null,
      searchFullName: null,
      searchRole: null,
      viewModel: null,
      statuFilter: [],
      roleFilter: [],
      roles: [],
      loading: false,
      permissions: null,
      filterOptions: {
        status: ''
      },
      modalImport: {
        isVisible: false,
        isLoading: false,
        title: 'IMPORTAR ROLES',
        onUploadImport: 'onUploadImportRole',
        onCancelImport: 'onCancelImportRole'
      }
    }
  },
  mounted() { 
    EventBus.$on('onSubmitedRole', this.onSearch);
    EventBus.$on('onUploadImportRole', this.onUploadImport);
    EventBus.$on('onCancelImportRole', this.onCancelImport);
  },
  beforeDestroy() {
    EventBus.$off('onSubmitedRole', this.onSearch);
    EventBus.$off('onUploadImportRole', this.onUploadImport);
    EventBus.$off('onCancelImportRole', this.onCancelImport);
  },
  created() {
    this.viewModel = new RoleViewModel(this, 'Roles');
    this.onActive();
  },
  methods: {
    onActive() {
      this.onSearch();
    },
    onAllFilterChange(data, field){
      this.onFilterChange(data, field);
    },
    onShowImport() {
      this.viewModel.showModal(this.modalImport, true);
    },
    onUploadImport(file){
      this.viewModel.showModalLoading(this.modalImport, true);
      this.viewModel.import(file);
    },
    onCancelImport(){
      this.viewModel.showModal(this.modalImport, false);
    },
    onExportToExcel() {
      this.viewModel.exportToExcel();
    },
    onCanCreate() {
      return this.canCreate(this.modulePermissions)
    },
    onCanRead() {
      return this.canRead(this.modulePermissions)
    },
    onCanUpdate() {
      return this.canUpdate(this.modulePermissions)
    },
    onCanDelete() {
      return this.canDelete(this.modulePermissions)
    },
  },
  computed: {}
}